import {
  ApiAssignAssetsToUser,
  ApiAssignStakingRiskProductToUser,
  ApiGetAllAssets,
  ApiGetAllStakingRiskProductsUserInfo,
  createListingAssets,
  deleteListingAssets,
  getListingAssets,
  getListingSingleAsset,
  updateListingAssets,
} from "../../Services";
import {
  ASSIGN_UPDATING_ASSET,
  ASSIGN_UPDATING_ASSET_ERROR,
  ASSIGN_UPDATING_STAKING_RISK_TO_USER,
  ASSIGN_UPDATING_STAKING_RISK_TO_USER_ERROR,
  LISTING_ASSETS_LIST,
  LISTING_ASSET_ERROR,
  LISTING_CREATING_ASSET,
  LISTING_CREATING_ASSET_START,
  LISTING_DELETING_ASSET,
  LISTING_SINGLE_ASSET,
  LISTING_UPDATING_ASSET,
  LISTING_UPDATING_ASSET_START,
  SELECT_ALL_ASSETS_DATA,
  SELECT_ALL_STAKING_RISK_DATA,
} from "../Reducers/ListingAssetsReducer";
import { showSuccessMessage } from "../../Helpers/ErrorMessages";

export function getAllAssetsThunk(userId) {
  return (dispatch) => {
    ApiGetAllAssets(userId).then((result) => {
      dispatch({
        type: SELECT_ALL_ASSETS_DATA,
        payload: {
          data: result?.data?.data,
        },
      });
    });
  };
}

export function assignAssetsToUserThunk(list, userId) {
  return (dispatch) => {
    ApiAssignAssetsToUser(list, userId)
      .then((e) => {
        dispatch({
          type: ASSIGN_UPDATING_ASSET,
        });
        showSuccessMessage("Changes were saved");
        dispatch(getAllAssetsThunk(userId));
      })
      .catch((e) => {
        return dispatch({
          type: ASSIGN_UPDATING_ASSET_ERROR,
          payload: {
            errors: e?.response?.data,
          },
        });
      });
  };
}

export function getAllStakingRiskProductsUserInfoThunk(userId) {
  return (dispatch) => {
    ApiGetAllStakingRiskProductsUserInfo(userId).then((result) => {
      console.log(result, "results");
      dispatch({
        type: SELECT_ALL_STAKING_RISK_DATA,
        payload: {
          data: result?.data?.data,
        },
      });
    });
  };
}

export function assignStakingRiskProductToUserThunk(
  userId,
  stakingRiskUserInfos,
) {
  return (dispatch) => {
    ApiAssignStakingRiskProductToUser(userId, stakingRiskUserInfos)
      .then((e) => {
        dispatch({
          type: ASSIGN_UPDATING_STAKING_RISK_TO_USER,
        });
        showSuccessMessage("Changes were saved");
      })
      .catch((e) => {
        return dispatch({
          type: ASSIGN_UPDATING_STAKING_RISK_TO_USER_ERROR,
          payload: {
            errors: e?.response?.data,
          },
        });
      });
  };
}

export function GetListingAssetsThunk(param = null) {
  return (dispatch) => {
    getListingAssets(param).then((result) => {
      dispatch({
        type: LISTING_ASSETS_LIST,
        payload: {
          result: result.data.data,
        },
      });
    });
  };
}

export function GetListingSingleAssetThunk(id) {
  return (dispatch) => {
    getListingSingleAsset(id).then((result) => {
      dispatch({
        type: LISTING_SINGLE_ASSET,
        payload: {
          result: result.data.data,
        },
      });
    });
  };
}

let createListingAssetInFlight = false;

export function CreateListingAssetsThunk(data) {
  return (dispatch) => {
    if (createListingAssetInFlight) {
      return Promise.resolve();
    }

    createListingAssetInFlight = true;
    dispatch({ type: LISTING_CREATING_ASSET_START });

    return createListingAssets(data)
      .then((e) =>
        dispatch({
          type: LISTING_CREATING_ASSET,
        }),
      )
      .catch((e) => {
        return dispatch({
          type: LISTING_ASSET_ERROR,
          payload: {
            errors: e?.response?.data,
          },
        });
      })
      .finally(() => {
        createListingAssetInFlight = false;
      });
  };
}

let updateListingAssetInFlight = false;

export function UpdateListingAssetsThunk(data, id, { trackLoading = false } = {}) {
  return (dispatch) => {
    if (trackLoading && updateListingAssetInFlight) {
      return Promise.resolve();
    }

    if (trackLoading) {
      updateListingAssetInFlight = true;
      dispatch({ type: LISTING_UPDATING_ASSET_START });
    }

    return updateListingAssets(data, id)
      .then((e) =>
        dispatch({
          type: LISTING_UPDATING_ASSET,
        }),
      )
      .catch((e) => {
        return dispatch({
          type: LISTING_ASSET_ERROR,
          payload: {
            errors: e?.response?.data,
          },
        });
      })
      .finally(() => {
        if (trackLoading) {
          updateListingAssetInFlight = false;
        }
      });
  };
}

const deleteListingAssetTasks = new Map();

export function DeleteListingAssetsThunk(id, type = null, cb = undefined) {
  return (dispatch) => {
    const key = `${id}:${type}`;
    const pendingTask = deleteListingAssetTasks.get(key);
    if (pendingTask) {
      return pendingTask;
    }

    const task = deleteListingAssets(id, type)
      .then((result) => {
        dispatch({
          type: LISTING_DELETING_ASSET,
        });
        if (cb) {
          cb();
        }
        return result;
      })
      .catch((e) => {
        const errors = e?.response?.data;
        dispatch({
          type: LISTING_ASSET_ERROR,
          payload: {
            errors,
          },
        });
        return Promise.reject(errors ?? e);
      })
      .finally(() => {
        deleteListingAssetTasks.delete(key);
      });

    deleteListingAssetTasks.set(key, task);
    return task;
  };
}
